import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import {
  Grid,
  IconButton,
  Chip,
  Typography,
  TextField,
  Button,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import HelpIcon from "@material-ui/icons/Help";
import { setSelectedTag, setSavedSelectedTagData, setDrawerTagTip, setAssetComment, setSavedCommentData,
  setSelectedTagNtt, setSavedSelectedTagDataNtt, setSavedCommentDataHokuden
 } from "../../actions";
import TagConfig from "../../config/TagConfig";
import LocalStorageHelper from "../../utils/helper/localstorage_helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      width: "100%",
    },
    title: {
      fontSize: 12,
      color: "#484848",
    },
    item: {
      marginTop: theme.spacing(1),
    },
    filtered: {
      flex: 1,
      width: "100%",
      maxWidth: 1200,
      margin: "0 auto",
      boxSizing: "border-box",
      position: "relative",
    },
    iconTooltip: {
      fontSize: 18,
      marginTop: -4,
      marginLeft: 4,
    },
    tagSelect: {
      marginTop: theme.spacing(1),
      fontSize: 16,
      minWidth: 600,
      maxWidth: 1000,
      "& .MuiInputLabel-root": {
        fontSize: "16px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "16px", // Customize input text size (if needed)
      }
    },
    tagSelectNtt: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(2),
      fontSize: 16,
      minWidth: 200,
      maxWidth: 200,
      "& .MuiInputLabel-root": {
        fontSize: "16px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "16px", // Customize input text size (if needed)
      }
    },
    tagWrapper: {
      display: "flex",
    },
    tagDropdown: {
      marginLeft: -32,
    },
    saveButton: {
      fontWeight: "medium",
      height: 30,
      marginTop: 12,
      marginLeft: 16,
      paddingTop: 8,
    },
    formWrapper: {
      display: "flex",
    },
    form: {
      marginRight: 16,
      width: "85.9%",
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
      },
    }
  })
);

const ImageMeta = ({
  periodType,
  viewer,
  setSelectedTag,
  selectedTag,
  setSavedSelectedTagData,
  tagSavingLoader,
  commentSavingLoader,
  setDrawerTagTip,
  openTagTip,
  setAssetComment,
  setSavedCommentData,
  assetComment,
  noInput,
  numOfImage,
  setSelectedTagNtt,
  selectedTagNtt,
  setSavedSelectedTagDataNtt,
  setSavedCommentDataHokuden,
}) => {
  const classes = useStyles();
  const [tagData, setTagData] = useState([]);
  const [tagDataNtt] = useState(TagConfig.resultTagNtt);
  const [selectedRejectReason, setSelectedRejectReason] = useState(null);
  const selectedValue = selectedTagNtt?.tags || null;
  const companyName = LocalStorageHelper.getCompany();
  const isTepco = companyName === "tepco";
  const isNtt = companyName.includes("ntt") || companyName === "okiden";
  const isHokuden = companyName === "hokuden";
  const isMitsubishi = companyName === "mitsubishi";
  const isPlot = viewer?.[0]?.plot_id !== undefined || viewer?.[0]?.plotId !== undefined;
  const plotPhotoCount = viewer?.[0]?.photo_count ?? viewer?.[0]?.photoCount ?? numOfImage ?? viewer?.length ?? 0;
  const plotId = viewer?.[0]?.plotId ?? viewer?.[0]?.plot_id ?? "-";
  const assetType = viewer?.[0]?.assetType ?? viewer?.[0]?.asset_type ?? "-";
  const assetSubType = viewer?.[0]?.assetSubType ?? viewer?.[0]?.asset_sub_type ?? "";
  const confidenceScore = viewer?.[0]?.confidenceScore ?? viewer?.[0]?.confidence_score ?? "-";
  const latitude = viewer?.[0]?.latitude ?? "-";
  const longitude = viewer?.[0]?.longitude ?? "-";
  const municipalityName = viewer?.[0]?.municipalityName ?? viewer?.[0]?.municipality_name ?? "-";
  const photographerName = viewer?.[0]?.photographerName ?? viewer?.[0]?.name ?? "-";
  const photographedDatetime = viewer?.[0]?.photographedDatetimeJst ?? viewer?.[0]?.photographed_datetime_jst ?? viewer?.[0]?.occurred_datetime_jst ?? "-";

  useEffect(() => {
    if (periodType === "season") {
      setTagData(TagConfig.seasonTag);
    } else {
      setTagData(TagConfig.missionTagB.concat(TagConfig.missionTagC));
    }
  }, [periodType]);

  useEffect(() => {
    if (selectedTagNtt?.tags === "false") {
      handleSelectTagChangeNtt("false"); // ← タグ変更なしでも再更新
    }
  }, [selectedRejectReason]);

  useEffect(() => {
    if (
      selectedTagNtt?.tags === "false" &&
      selectedTagNtt?.reject_reason &&
      TagConfig.nttmeRejectReasons?.length > 0
    ) {
      const matchedReason = TagConfig.nttmeRejectReasons.find(
        (reason) => reason.value === selectedTagNtt.reject_reason
      );
      setSelectedRejectReason(matchedReason || null);
    }
  }, [selectedTagNtt, TagConfig.nttmeRejectReasons]);

  const handleSelectTagChange = (tags) => {
    console.log("LOG:: viewer[0]:", viewer[0]);
    const savingTagData = {
      tags: tags,
      fileName: viewer[0].file_name,
      object_key: viewer[0].object_key,
      occurred_datetime: viewer[0].occurred_datetime,
      game_space_id: viewer[0].game_space_id,
      game_space_type: viewer[0].game_space_type,
      review_request_id: viewer[0].review_request_id,
      photo_of_power_asset_id: viewer[0].photo_of_power_asset_id,
      place_code: viewer[0].place_code,
      sign_number: viewer[0].sign_number,
      equipment_number: viewer[0].equipment_number,
      player_id: viewer[0].player_id,
      player_name: viewer[0].name,
    }
    console.log("LOG savingTagData:", savingTagData);
    setSelectedTag(savingTagData);
  };

  const handleSelectTagChangeNtt = (tags) => {
    if (!viewer || viewer.length === 0) return;
    const savingTagData = {
      tags: tags,
      fileName: viewer[0].file_name,
      object_key: viewer[0].object_key,
      occurred_datetime: viewer[0].occurred_datetime,
      game_space_id: viewer[0].game_space_id,
      review_request_id: viewer[0].review_request_id,
      player_id: viewer[0].player_id,
      player_name: viewer[0].name,
      power_asset_id: viewer[0].photo_of_power_asset_id,
      power_asset_photography_target_id: viewer[0].power_asset_photography_target_id,
      game_term_id: viewer[0].game_term_id,
      game_field_id: viewer[0].game_field_id,
      prefectural_area: viewer[0].prefectural_area,
      exchange_office_name: viewer[0].exchange_office_name,
      asset_info: viewer[0].asset_info,
      photography_target: viewer[0].photography_target,
      reject_reason: selectedRejectReason?.value || null,
      latitude: viewer[0].latitude,
      longitude: viewer[0].longitude,
      sub_type: viewer[0].sub_type,
    };
    setSelectedTagNtt(savingTagData);
  };

  const handleCommentChange = (event) => {
    const savingCommentData = {
      fileName: viewer[0].file_name,
      object_key: viewer[0].object_key,
      occurred_datetime: viewer[0].occurred_datetime,
      game_space_id: viewer[0].game_space_id,
      game_space_type: viewer[0].game_space_type,
      review_request_id: viewer[0].review_request_id,
      photo_of_power_asset_id: viewer[0].photo_of_power_asset_id,
      place_code: viewer[0].place_code,
      sign_number: viewer[0].sign_number,
      equipment_number: viewer[0].equipment_number,
      player_id: viewer[0].player_id,
      player_name: viewer[0].name,
      comment: event.target.value,
    }
    setAssetComment(savingCommentData);
  };

  const handleCommentChangeHokuden = (event) => {
    const savingCommentData = {
      fileName: viewer[0].file_name,
      object_key: viewer[0].object_key,
      occurred_datetime: viewer[0].occurred_datetime,
      game_space_id: viewer[0].game_space_id,
      game_space_type: "season",
      review_request_id: viewer[0].review_request_id,
      photo_of_power_asset_id: viewer[0].photo_of_power_asset_id,
      power_pole_number: viewer[0].power_pole_number,
      city_name: viewer[0].representative_municipality_name,
      city_code: viewer[0].representative_municipality_code,
      branch_code: viewer[0].branch_code,
      player_id: viewer[0].player_id,
      player_name: viewer[0].name,
      comment: event.target.value,
    }
    setAssetComment(savingCommentData);
  };

  const isSaveDisabled =
  selectedValue === "true"
    ? false
    : selectedValue === "false"
      ? !selectedRejectReason?.value
      : selectedValue === "pending"
        ? false
        : true;

  return (
    <div className={classes.container}>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        className={classes.filtered}
      >
        {viewer.length > 0 && (
          <>
            {isPlot && (
              <>
                <Grid item className={classes.item} xs={4} md={2}>
                  <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                    プロットID：
                  </Typography>
                  <span style={{ fontSize: 12 }}>{plotId}</span>
                </Grid>
                <Grid item className={classes.item} xs={4} md={2}>
                  <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                    アセット種別：
                  </Typography>
                  {/* {assetSubType ? `${assetType} | ${assetSubType}` : assetType} */}
                  <span style={{ fontSize: 12 }}>{assetType}</span>
                </Grid>
                <Grid item className={classes.item} xs={4} md={2}>
                  <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                    信頼度スコア：
                  </Typography>
                  {confidenceScore}
                </Grid>
                <Grid item className={classes.item} xs={4} md={2}>
                  <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                    座標：
                  </Typography>
                  {latitude} , {longitude}
                </Grid>
                <Grid item className={classes.item} xs={4} md={2}>
                  <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                    自治体：
                  </Typography>
                  {municipalityName}
                </Grid>
              </>
            )}
            {((isTepco && viewer[0]["sign_number"] !== undefined) ||
              (isNtt && viewer[0]["prefectural_area"] !== undefined) ||
              (isHokuden && viewer[0]["power_pole_number"] !== undefined)) && (
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                  {isTepco && `標識番号 | 標識名：`}
                  {isNtt && `県域 | 収容局名 :`}
                  {isHokuden && `電柱番号 :`}
                </Typography>
                {isTepco && `${viewer[0]["sign_number"]} | ${viewer[0]["sign_name"]}`}
                {isNtt && `${viewer[0]["prefectural_area"]} | ${viewer[0]["exchange_office_name"]}`}
                {isHokuden && `${viewer[0]["power_pole_number"]}`}
              </Grid>
            )}
            {((isTepco && viewer[0]["equipment_number"] !== undefined) ||
              (isNtt && viewer[0]["asset_info"] !== undefined) ||
              (isHokuden && viewer[0]["representative_municipality_name"] !== undefined)) && (
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                  {isTepco && `設備番号 | スキーマ番号：`}
                  {isNtt && `電柱情報 :`}
                  {isHokuden && `市町村名 :`}
                </Typography>
                {isTepco && `${viewer[0]["equipment_number"]} | ${viewer[0]["place_code"]}`}
                {isNtt && `${viewer[0]["asset_info"]}`}
                {isHokuden && `${viewer[0]["representative_municipality_name"]}`}
              </Grid>
            )}
            {isNtt &&
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影対象：</Typography>
                {viewer[0]["photography_target"] !== undefined
                ? `${viewer[0]["photography_target"]}`
                : "-"}
              </Grid>
            }
            {isHokuden &&
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>支店コード：</Typography>
                {viewer[0]["branch_code"] !== undefined
                ? `${viewer[0]["branch_code"]}`
                : "-"}
              </Grid>
            }
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影点数：</Typography>
              {numOfImage ? numOfImage : viewer.length}
            </Grid>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影者 (Player ID)：</Typography>
              {viewer[0].name} <br /><span style={{fontSize: 12}}>{viewer[0].player_id}</span>
            </Grid>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影日時：</Typography>
              {viewer[0].occurred_datetime_jst
                ? viewer[0].occurred_datetime_jst.slice(0, 19).replace("T", " ")
                : "-"}
            </Grid>
            {isTepco &&
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>高圧設備：</Typography>
              {viewer[0]["insulated_switch"] === null || viewer[0]["insulated_switch"] === undefined
                ? `無`
                : "有"}
            </Grid>
            }
            {isTepco && !noInput &&
            <Grid item className={classes.item} xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                className={classes.filtered}
              >
                <Grid item className={classes.item} xs={12} md={6} lg={2}>
                  <div style={{ color: "rgba(0, 0, 0, 0.54)", fontSize: 14 }}>結果入力
                    <IconButton
                      className={classes.iconTooltip}
                      color="inherit"
                      aria-label="open drawer"
                      onClick={() => setDrawerTagTip(!openTagTip)}
                      disableRipple={true}
                      disableFocusRipple={true}
                    >
                      <HelpIcon
                        fontSize="small"
                      />
                    </IconButton>
                  ：
                  </div>
                </Grid>
                <Grid item className={classes.tagDropdown} xs={12} md={12} lg={8}>
                {tagData !== null && tagData.length > 0 && (
                  <div className={classes.tagWrapper}>
                  <Autocomplete
                    multiple
                    id="tag-select-autocomplete"
                    options={tagData}
                    getOptionLabel={(option) => option.value || ""}
                    getOptionSelected={(option, value) => option.value.toString() === value.toString()}
                    value={selectedTag.tags !== undefined &&
                          selectedTag.tags.length > 0
                            ? tagData.filter(tag => selectedTag.tags.includes(tag.value.toString()))
                            : []}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const selectedValues = newValue.map((tag) => tag.value.toString());
                        handleSelectTagChange(selectedValues);
                      } else {
                        handleSelectTagChange([]);
                      }
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={index}
                          size="small"
                          label={option.value}
                          {...getTagProps({ index })}
                          style={{ backgroundColor: '#ffed6f', color: 'black' }} // Set Chip color
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={selectedTag.tags !== undefined && selectedTag.tags.length < 1 ? "選択する" : ""}
                        className={classes.tagSelect}
                      />
                    )}
                    renderOption={(option) => (
                      <div style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                        <Typography variant="body1">
                          {option.tip}
                        </Typography>
                      </div>
                    )}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    color="default"
                    className={classes.saveButton}
                    onClick={companyName === "tepco" ? setSavedSelectedTagData : setSavedCommentDataHokuden}
                    disabled={companyName === "tepco" ? true : false}
                  >
                    {tagSavingLoader ? "保存中.." : "保存"}
                  </Button>
                  </div>
                )}
                </Grid>
              </Grid>
            </Grid>
            }
           {!isNtt && !isMitsubishi && !noInput && (
            <Grid item className={classes.item} xs={12}>
              <Grid container direction="row" alignItems="flex-start" className={classes.filtered}>
                <Grid item className={classes.item} xs={12} md={8} lg={9}>
                  <div className={classes.formWrapper}>
                    <form className={classes.form} noValidate autoComplete="off">
                      <TextField
                        id="outlined-multiline-static"
                        multiline
                        defaultValue={assetComment || ""}
                        variant="outlined"
                        placeholder="コメント入力 (最大400字)"
                        fullWidth
                        inputProps={{ style: { fontSize: 13, marginTop: -8, padding: '2px 4px' } }}
                        onChange={isTepco ? handleCommentChange : handleCommentChangeHokuden}
                      />
                    </form>
                    <Button
                      variant="outlined"
                      size="small"
                      color="default"
                      className={classes.saveButton}
                      style={{ height: '100%', marginLeft: 8 }}
                      onClick={isTepco ? setSavedSelectedTagData : setSavedCommentDataHokuden}
                    >
                      {commentSavingLoader ? "保存中.." : "保存"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )}
          {companyName.includes("ntt") && (
            <Grid container spacing={2} alignItems="center" style={{ marginLeft: 32, marginTop: 16 }}>
              {/* NTTME 判定結果 */}
              {periodType === "season" && (
              <>
              <Grid item>
                <div style={{ color: "rgba(0, 0, 0, 0.54)", fontSize: 14 }}>
                  {companyName === "ntt" && `NTTME判定結果：`}
                  {(companyName === "ntt-ft" || companyName === "okiden") && `判定結果：`}
                </div>
              </Grid>
              <Grid item>
                <Autocomplete
                  id="tag-select-autocomplete-ntt"
                  options={tagDataNtt}
                  getOptionLabel={(option) => option?.label || ""}
                  getOptionSelected={(option, value) =>
                    option.value === value?.value
                  }
                  value={
                    selectedTagNtt.tags
                      ? tagDataNtt.find((tag) => tag.value === selectedTagNtt.tags)
                      : null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      handleSelectTagChangeNtt(newValue.value);
                    } else {
                      handleSelectTagChangeNtt(null);
                    }
                  }}
                  disableClearable
                  style={{ minWidth: 180 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder={
                        !selectedTagNtt.tags || selectedTagNtt.tags.length === 0 ? "選択する" : ""
                      }
                      className={classes.tagSelectNtt}
                    />
                  )}
                />
              </Grid>

              {/* 不合格理由（不合格選択時のみ表示） */}
              {selectedTagNtt.tags === "false" && (
                <>
                  <Grid item>
                    <div style={{ color: "rgba(0, 0, 0, 0.54)", fontSize: 14 }}>不合格理由：</div>
                  </Grid>
                  <Grid item>
                    <Autocomplete
                      id="nttme-reject-reason-autocomplete"
                      options={TagConfig.nttmeRejectReasons}
                      getOptionLabel={(option) => option?.label || ""}
                      getOptionSelected={(option, value) =>
                        !!option && !!value && option.value === value.value
                      }
                      value={selectedRejectReason}
                      onChange={(event, newValue) => {
                        setSelectedRejectReason(newValue || null);
                      }}
                      disableClearable
                      style={{ minWidth: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder="理由を選択"
                          className={classes.rejectReasonSelect}
                        />
                      )}
                    />
                  </Grid>
                </>
              )}

              {/* 保存ボタン */}
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  color="default"
                  className={classes.saveButton}
                  onClick={setSavedSelectedTagDataNtt}
                  disabled={isSaveDisabled}
                >
                  {tagSavingLoader ? "保存中.." : "保存"}
                </Button>
              </Grid>
              </>
              )}
            </Grid>
          )}
          </>
        )}
      </Grid>
    </div>
  );
};

ImageMeta.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  periodType: state.app.periodType,
  selectedTag: state.app.selectedTag,
  tagSavingLoader: state.app.tagSavingLoader,
  openTagTip: state.app.openTagTip,
  commentSavingLoader: state.app.commentSavingLoader,
  assetComment: state.app.assetComment,
  selectedTagNtt: state.app.selectedTagNtt,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedTag: (param) => dispatch(setSelectedTag(param)),
  setSavedSelectedTagData: (param) => dispatch(setSavedSelectedTagData(param)),
  setDrawerTagTip: (param) => dispatch(setDrawerTagTip(param)),
  setAssetComment: (param) => dispatch(setAssetComment(param)),
  setSavedCommentData: (param) => dispatch(setSavedCommentData(param)),
  setSavedSelectedTagDataNtt: (param) => dispatch(setSavedSelectedTagDataNtt(param)),
  setSelectedTagNtt: (param) => dispatch(setSelectedTagNtt(param)),
  setSavedCommentDataHokuden: (param) => dispatch(setSavedCommentDataHokuden(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(ImageMeta));
